import ApiService from "@/api/baseApi/api-service";
import { Config } from "../../config";
import {
  IGetProductDetails,
  IGetProductDetailsParams,
  IGetProductSEOData,
} from "./interfaces/api-product-details-interface";
import {
  ICrossSellProductsParams,
  ICrossSellProductsResult,
  IGetProductResult,
  IProductsGetAllParams,
  IProductsSearchParams,
  IProductsSearchResult,
} from "./interfaces/api-product-interfaces";

const URLs = {
  getProducts: "/products",
  crossSell: "/products/cross-sell",
  search: "/products/search",
  SEOData: "/seo-data",
};
class ApiProducts extends ApiService {
  constructor(config: Config) {
    super({ ...config });
  }
  getProducts = (params: IProductsGetAllParams): Promise<IGetProductResult> =>
    this.get(URLs.getProducts, { params });
  getCrossSellProducts = (
    params: ICrossSellProductsParams,
  ): Promise<ICrossSellProductsResult> => this.get(URLs.crossSell, { params });
  searchProducts = (
    params: IProductsSearchParams,
  ): Promise<IProductsSearchResult> => this.get(URLs.search, { params });
  getProductDetails = (
    params: IGetProductDetailsParams,
  ): Promise<IGetProductDetails> => {
    return this.get(URLs.getProducts + "/" + params.id, { params });
  };
  getProductSEOData = (
    params: IGetProductDetailsParams,
  ): Promise<IGetProductSEOData> => {
    return this.get(`${URLs.getProducts}/${params.id}${URLs.SEOData}`, {});
  };
  toggleWishlist = (
    id: number,
    params?: {
      fbc?: string | null;
      fbp?: string | null;
      event_id?: string;
      ttp?: string | null;
      ttclid?: string | null;
      twclid?: string | null;
    },
  ) => {
    return this.post(`/products/${id}/toggle-wishlist`, {}, { params });
  };
}
export default ApiProducts;
